if (!customElements.get('localization-component')) {
  customElements.define(
    'localization-component',
    class LocalizationComponent extends HTMLElement {
      constructor() {
        super();
        this.openDrawerButton = document.querySelectorAll('[data-open-localization]');
        this.closeDrawerButton = document.querySelectorAll('[data-close-localization]');
        this.languageForm = this.querySelector('[data-language-form]');
        this.languageInput = this.querySelector('input[name="locale_code"]');
        this.languageButtons = this.querySelectorAll('[data-change-language]');
        this.countryForm = this.querySelector('[data-country-form]');
        this.countryInput = this.querySelector('input[name="country_code"]');
        this.countryButtons = this.querySelectorAll('[data-country-change]');
        this.searchInput = this.querySelector('[data-country-search]');
        this.setupEventListeners();
      }

      setupEventListeners() {
        this.openLocalization();
        this.closeLocalization();
        this.changeLanguage();
        this.changeCountry();
        this.initSearch();
      }

      openLocalization() {
        if (this.openDrawerButton.length === 0) return;
        this.openDrawerButton.forEach((button) => {
          button.addEventListener('click', () => {
            this.setAttribute('aria-hidden', 'false');
            document.body.style.overflow = 'hidden';
          });
        });
      }

      closeLocalization() {
        if (this.closeDrawerButton.length === 0) return;
        this.closeDrawerButton.forEach((button) => {
          button.addEventListener('click', () => {
            this.setAttribute('aria-hidden', 'true');
            document.body.style.overflow = 'auto';
          });
        });
      }

      changeLanguage() {
        if (this.languageButtons.length === 0 || !this.languageForm) return;
        this.languageButtons.forEach((button) =>
          button.addEventListener('click', (event) => {
            event.preventDefault();
            const isButtonCurrent = button.hasAttribute('aria-current');
            if (isButtonCurrent) return;
            if (!this.languageInput) return;
            this.languageInput.value = button.getAttribute('lang');
            this.languageForm.submit();
          })
        );
      }

      changeCountry() {
        if (this.countryButtons.length === 0 || !this.countryForm) return;
        this.countryButtons.forEach((button) =>
          button.addEventListener('click', (event) => {
            event.preventDefault();
            const isButtonCurrent = button.hasAttribute('aria-current');
            if (isButtonCurrent) return;
            if (!this.countryInput) return;
            this.countryInput.value = button.getAttribute('data-country-code');
            this.countryForm.submit();
          })
        );
      }

      initSearch() {
        if (!this.searchInput || this.countryButtons.length === 0) return;
        this.searchInput.addEventListener('input', (event) => {
          const searchTerm = event.target.value.toLowerCase();
          this.countryButtons.forEach((button) => {
            const countryName = button.dataset.country;
            countryName.startsWith(searchTerm) ? (button.style.display = 'flex') : (button.style.display = 'none');
          });
        });
      }
    }
  );
}
